import React, { useEffect, useState } from 'react';
import { ActivityIndicator, StatusBar, View } from 'react-native';
import { QueryClientProvider } from '@tanstack/react-query';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { AuthProvider } from './auth/AuthProvider';
import { initApi } from './lib/api';
import { queryClient } from './lib/query';
import { hydrateStorage } from './lib/storage';
import { RootNavigator } from './navigation/RootNavigator';
import { ThemeProvider, ToastProvider, useTheme } from './ui';

function Themed() {
  const { colors, dark } = useTheme();
  return (
    <View style={{ flex: 1, backgroundColor: colors.bg }}>
      <StatusBar barStyle={dark ? 'light-content' : 'dark-content'} />
      <ToastProvider>
        <AuthProvider>
          <RootNavigator />
        </AuthProvider>
      </ToastProvider>
    </View>
  );
}

export default function App() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    hydrateStorage().then(() => {
      initApi();
      setReady(true);
    });
  }, []);
  return (
    <SafeAreaProvider>
      <QueryClientProvider client={queryClient}>
        {ready ? (
          <ThemeProvider>
            <Themed />
          </ThemeProvider>
        ) : (
          <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
            <ActivityIndicator color="#4f46e5" />
          </View>
        )}
      </QueryClientProvider>
    </SafeAreaProvider>
  );
}
